import { AfterViewInit, Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ModulemanagementService } from 'src/app/services/modules/modulemanagement.service';
import { environment } from 'src/environments/environment';
import { ComponentheaderService } from 'src/app/services/componentheader.service';
import { UseraccessserviceService } from 'src/app/services/useraccessservice.service';

import {
  FormBuilder,
  FormGroup,
  Validators,
  AbstractControl,
  ValidationErrors
} from '@angular/forms';
import { ToastrService } from 'ngx-toastr';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'app-enrollfrominvite',
  templateUrl: './enrollfrominvite.component.html',
  styleUrls: ['./enrollfrominvite.component.css']
})
export class EnrollfrominviteComponent implements OnInit {
  readonly userTokenLocalStorageKey = environment.userTokenStore;
  form: FormGroup;
  moduleName: string;
  schoolName: string;
  paramInToken: string;
  strength = 0;

  constructor(private activatedroute: ActivatedRoute, private useraccessservice: UseraccessserviceService, public modulemanager: ModulemanagementService, 
    private fb: FormBuilder, private headerinfo: ComponentheaderService, private toastr: ToastrService) 
  {
    this.form = this.fb.group(
      {
        fname: ['', Validators.required],
        lname: ['', Validators.required],
        password: [
          '',
          [
            Validators.required,
            Validators.minLength(8),
            Validators.maxLength(64),
            Validators.pattern(
              /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[\W_])[^\s]+$/
            )
          ]
        ],
        cpassword: ['', Validators.required]
      },
      {
        validators: this.passwordMatchValidator
      }
    );
  }

  async ngOnInit(): Promise<void> {
    this.paramInToken = this.activatedroute.snapshot.queryParamMap.get('p');
    this.moduleName = this.activatedroute.snapshot.queryParamMap.get('m');
    this.schoolName = this.activatedroute.snapshot.queryParamMap.get('s');

    this.headerinfo.setHeaderDisplay(this.schoolName + ': ' + this.moduleName, [], []);
    this.form.get('password')?.valueChanges
    .pipe(startWith(''))
    .subscribe(value => {
      this.strength = this.calculatePasswordStrength(value);
    });
  }
  async onboardStudent(){
    if (this.form.invalid) {
      this.form.markAllAsTouched();
      return;
    }
    try {
      let name = this.form.get('fname')?.value + ' ' + this.form.get('lname')?.value;
      const payload: any = await this.useraccessservice.userRegistrationFromInviteMail(
        this.paramInToken, name, this.form.get('password')?.value).toPromise();
      if (payload.token) {
        this.useraccessservice.setAuthenticatedUserToken(payload.token);
        window.location.href = payload.url + '&from=invitemail';
      }
      else {
        this.toastr.error("Account already exists, login to access account");
        setTimeout(()=>{
          if(payload.url)
            window.location.href = payload.url
        }, 1500);        
      }
    }
    catch(e){
      this.toastr.error("Registation failed");
    }
  }
  calculatePasswordStrength(password: string): number {
    let score = 0;
    if (!password) return score;

    // Length bonus
    if (password.length >= 8) score += 1;
    if (password.length >= 12) score += 1;

    // Uppercase
    if (/[A-Z]/.test(password)) score += 1;

    // Lowercase
    if (/[a-z]/.test(password)) score += 1;

    // Numbers
    if (/\d/.test(password)) score += 1;

    // Special characters
    if (/[\W_]/.test(password)) score += 1;

    return score; // Max 6
  }
  get strengthLabel(): string {
    switch (this.strength) {
      case 0:
      case 1:
      case 2: return 'Very Weak';
      case 3: return 'Weak';
      case 4: return 'Medium';
      case 5: return 'Strong';
      case 6: return 'Very Strong';
      default: return '';
    }
  }
  passwordMatchValidator(group: AbstractControl): ValidationErrors | null {
    const password = group.get('password')?.value;
    const confirm = group.get('cpassword')?.value;

    if (!password || !confirm) return null;
    return password === confirm ? null : { passwordMismatch: true };
  }
  get f() {
    return this.form.controls;
  }
}
